import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { observer, PropTypes as MobxPropTypes } from 'mobx-react'
import React from 'react'
import ReactCountryFlag from 'react-country-flag'

import { Button, Menu, Row } from 'antd'
import PropTypes from 'prop-types'

import locationSVG from '../../images/location.svg'
import { Dropdown } from '../Dropdown'

const { Item } = Menu

const CityDropdown = ({
  cities,
  selectCity,
  selectedCity,
  isShowFlag,
  isDisabled,
}) => {
  if (!cities?.length || !selectedCity.id) return null

  const menu = (
    <Menu
      className="qb-city-dropdown-menu"
      onClick={e => selectCity(e.key, false, false)}
    >
      {cities.map(city => (
        <Item className="qb-city-dropdown-option" key={city.id}>
          <Row type="flex" align="middle" justify="space-between">
            <div className="text">{city.name}</div>
            <ReactCountryFlag countryCode={city.region.name} svg />
          </Row>
        </Item>
      ))}
    </Menu>
  )

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      placement="bottomRight"
      getPopupContainer={trigger => trigger.parentNode}
      disabled={isDisabled}
    >
      <Button className="qb-city-dropdown-trigger" type="ghost" size="large">
        <Row type="flex" align="middle">
          <img src={locationSVG} alt="location-markder" />
          <span className="qb-city-dropdown-trigger-name">
            {selectedCity.name}
          </span>
          {isShowFlag && (
            <ReactCountryFlag countryCode={selectedCity.region.name} svg />
          )}
          <FontAwesomeIcon
            className="qb-city-dropdown-marker-icon"
            icon={['fal', 'chevron-down']}
          />
        </Row>
      </Button>
    </Dropdown>
  )
}

CityDropdown.propTypes = {
  cities: MobxPropTypes.arrayOrObservableArray,
  selectCity: PropTypes.func.isRequired,
  selectedCity: MobxPropTypes.objectOrObservableObject,
  isShowFlag: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

CityDropdown.defaultProps = {
  cities: [],
  selectedCity: {},
  isShowFlag: true,
  isDisabled: false,
}

export default observer(CityDropdown)
